/* eslint-disable jsx-a11y/control-has-associated-label */
import PropTypes from 'prop-types';
import React from 'react';

const LEFT_ARROW = 37;
const RIGHT_ARROW = 39;

class CalendarHeader extends React.Component {
  constructor(props) {
    super(props);
    this.setPrevMonthRef = (button) => { this.prevMonth = button; };
    this.setNextMonthRef = (button) => { this.nextMonth = button; };
    this.handleKeyDownOnArrow = this.handleKeyDownOnArrow.bind(this);
  }

  handleKeyDownOnArrow(e) {
    const { handleGoToNextMonth, handleGoToPreviousMonth } = this.props;
    switch (e.keyCode) {
      // Left Arrow
      case LEFT_ARROW: {
        handleGoToPreviousMonth();
        this.prevMonth.focus();
        break;
      }
      // Right Arrow
      case RIGHT_ARROW: {
        handleGoToNextMonth();
        this.nextMonth.focus();
        break;
      }
      default:
        break;
    }
  }

  render() {
    const { month, handleGoToNextMonth, handleGoToPreviousMonth } = this.props;

    return (
      <div>
        <button
          ref={this.setPrevMonthRef}
          className="ncss-btn-white pt2-sm pr5-sm pb2-sm pl5-sm"
          type="button"
          onClick={handleGoToPreviousMonth}
          onKeyDown={this.handleKeyDownOnArrow}
        >
          <div className="g72-chevron-left" />
        </button>
        <div className="current-month pt2-sm pl4-sm pr4-sm" style={{ display: 'inline-block' }}>
          <strong>{month}</strong>
        </div>
        <button
          ref={this.setNextMonthRef}
          className="ncss-btn-white pt2-sm pr5-sm pb2-sm pl5-sm"
          type="button"
          onClick={handleGoToNextMonth}
          onKeyDown={this.handleKeyDownOnArrow}
        >
          <div className="g72-chevron-right" />
        </button>
      </div>
    );
  }
}

CalendarHeader.propTypes = {
  handleGoToNextMonth: PropTypes.func.isRequired,
  handleGoToPreviousMonth: PropTypes.func.isRequired,
  month: PropTypes.string.isRequired,
};

// eslint-disable-next-line fp/no-mutation
CalendarHeader.displayName = 'CalendarHeader';

export default CalendarHeader;
